import React from 'react'
import {Routes, Route, Navigate} from 'react-router-dom';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



import AuthRoutes from './routes/AuthRoutes';
import MainRoutes from './routes/MainRoutes';

import UserProvider from './context/UserProvider';
import { ThemeProvider } from './context/ThemeContext';

function App() {
  return (
    <>
    <ToastContainer />
    <Routes>
        <Route path="/" element={<Navigate to="/login" />}/>
    </Routes>

    
    <ThemeProvider>
      <UserProvider>
      
        <AuthRoutes />
        <MainRoutes />
      
      </UserProvider>
    </ThemeProvider>
    
    
    
    
    
    </>
  );
}

export default App;
